<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import Cookie from 'js-cookie';

export default {
  data(){
    return {
    }
  },
  watch: {
    // 如果有路由传值值太长的话matomo会监听不到并报414，就不能根据router自动注册了：解决办法是在app.vue中监听router，然后设置
    $route(to, from) {
      if (process.env.NODE_ENV == 'development') return
      // 设置页面地址，可使用location.href，注意，如果使用的路由模式是hash模式，需要把url中的#号截取掉
      this.$matomo && this.$matomo.setCustomUrl(window.location.href)
      this.$matomo && this.$matomo.trackPageView(to.meta.title) //设置页面名称
    },
  },
}
</script>
<style>
#app {
  min-height: 100vh;
}
</style>
